/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-mixed-spaces-and-tabs */

import React, { useState, useEffect } from "react";
import secondsToHms from "../SecondsToHms/secondsToHms";
import card_img from "../../assets/images/card_img.png";
import lp_card_img from "../../assets/images/lp_card_img.png";
import certi_card_img from "../../assets/images/certi_card_img.png";
import jobaid_card_img from "../../assets/images/jobaid_card_img.png";
import durationIcon from "../../assets/images/duration.svg";
import {useNavigate} from "react-router-dom";
import moment from "moment";
import "./newCard.css";

function NewCard(props) {
    const cardDetails = props.data;
    const [showDescription, setShowDescription] = useState(false);
    const [countDays, setCountDays] = useState("");
    const [countDaysColor, setCountDaysColor] = useState("");
    const navigate = useNavigate();
    const crumbs = [
        { label: "Home", url: "/" },
    ];

    const navigateTo = (path) => {
        if(window.location.pathname.toLowerCase() === "/allcourses") {
            crumbs.push({ label: "All Courses", url: ("/allcourses" + window.location.search) });
            navigate(path, { state: { crumbs } });
        }
        else if (window.location.pathname.toLowerCase() === "/mylearning") {
            crumbs.push({ label: "My Learning", url: ("/mylearning" + window.location.search) });
            navigate(path, { state: { crumbs } });
        }
        else if (window.location.pathname.toLowerCase() === "/overdue-enrollments") {
            crumbs.push({ label: "Overdue Enrollments", url: ("/overdue-enrollments" + window.location.search) });
            navigate(path, { state: { crumbs } });
        }
        else {
            crumbs.push({ label: "Search Course", url: ("/searchcourse" + window.location.search) });
            navigate(path, { state: { crumbs } });
        }
    }

    const goToCourseDetails = (cid, lid) => {
        if (cardDetails.enrollment && cardDetails.enrollment === true) {
            navigateTo(`/coursedetails/${cid}/${lid}`);
        } else {
            navigateTo(`/coursedetails/${cid}`);
        }
    }

    useEffect(() => {
        if(cardDetails.dueDate){
            const dueDate = new Date(cardDetails?.dueDate);
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            const timeDifference = dueDate - currentDate;
            const Days = Math.floor(timeDifference / (1000 * 3600 * 24));
            let count="";
            if(Days > 0) {
                count = "Due in " +Days + " days";
                Days > 30 ? setCountDaysColor("dueNormal") : setCountDaysColor("dueOrange");
            }
            else if (Days === 0) {
                count = "Due Today";
                setCountDaysColor("dueOrange");
            }
            else {
                count = Math.abs(Days) + " Days Overdue";
                setCountDaysColor("dueRed");
            }
            setCountDays(count);
        }
    }, []);

    const imageUrl = cardDetails?.imageUrl || (() => {
        switch (cardDetails?.loType) {
        case "learningProgram":
            return lp_card_img;
        case "certification":
            return certi_card_img;
        case "jobAid":
            return jobaid_card_img;
        default:
            return card_img;
        }
    })();

    const onCardHoverIn = () => {
        setShowDescription(true);
    }

    const onCardHoverOut = () => {
        setShowDescription(false);
    }

    return (
        <React.Fragment>
            <div onClick={() => goToCourseDetails(cardDetails?.id, cardDetails.instancesId)} className="new-card">
                <div className="sec1">
                    <div className="lotype">
                        <span className="capsWord">{cardDetails?.loType === "learningProgram" ? "Learning Path" : cardDetails?.loType}</span>
                    </div>
                    {cardDetails?.dueDate && cardDetails.enrollment && cardDetails.state != "COMPLETED" && countDays != "" && (
                        <div className={countDaysColor}
                            title={`Due Date: ${moment(cardDetails?.dueDate).format("MMM Do YYYY")}`}>
                            <span>{countDays}</span>
                        </div>
                    )
                    }
                </div>
                <div className="img-block" style={{backgroundImage: `url(${imageUrl})`}}
                    onMouseEnter={() => onCardHoverIn()}
                    onMouseLeave={() => onCardHoverOut()}
                >
                    {
                        showDescription ? (
                            <div className="on-hover">
                                <span className="title">
                                    <b>{cardDetails?.name}</b>
                                </span>
                                <span className="description">
                                    {cardDetails?.description}
                                </span>
                            </div>
                        ) : (
                            <div className="is-normal">
                                <span className="title">
                                    <b>{cardDetails?.name}</b>
                                </span>
                            </div>
                        )
                    }
                </div>
                <div style={{margin: "6px 15px", height: "6px"}}>
                    {cardDetails?.enrollment && (
                        <div className="progress custom-progress">
                            <div
                                className="progress-bar"
                                role="progressbar"
                                style={{ width: `${cardDetails?.progressPercent}%`}}
                                aria-valuenow={cardDetails?.progressPercent}
                                aria-valuemin="0"
                                aria-valuemax="100"
                            >
                                <span
                                    style={{
                                        left: `${cardDetails?.progressPercent}%`,
                                        transform: `translateX(-${cardDetails?.progressPercent}%)`,
                                    }}
                                >
                                    {cardDetails?.progressPercent}%
                                </span>
                            </div>
                        </div>
                    )}
                </div>
                <div className="sec2">
                    <div>
                        <img src={durationIcon} alt="" className="duration-img"></img>
                        <span>{(cardDetails?.duration !== 0 && cardDetails?.duration !== undefined)?(secondsToHms(cardDetails?.duration)).trim(): "No Duration"}</span>
                    </div>
                    {cardDetails?.enrollment &&
                            <div><span>{cardDetails?.progressPercent}%</span></div>
                    }
                </div>
            </div>
        </React.Fragment>
    );
}


export default NewCard;
